import { render, staticRenderFns } from "./VideoPlayerCustom.vue?vue&type=template&id=2e70a01b&scoped=true"
import script from "./VideoPlayerCustom.vue?vue&type=script&lang=js"
export * from "./VideoPlayerCustom.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayerCustom.vue?vue&type=style&index=0&id=2e70a01b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e70a01b",
  null
  
)

export default component.exports